import React from 'react';
import { Tooltip as ReactTooltip } from "react-tooltip";

import { F1PasswordManagement } from 'models/config/F1PasswordManagement';

export type PasswordTooltipProps = {
    passwordValidate: any;
    config: F1PasswordManagement | undefined;
};

export const PasswordHintTooltip = (props: PasswordTooltipProps) => {
    const { passwordValidate, config } = props;

    return (
        <ReactTooltip
            id="global"
            place="left"
        >
            <ul>
                <li
                    style={{
                        color: passwordValidate['maxLength']
                            ? 'green'
                            : 'white'
                    }}
                >
                    {' '}
                    รหัสผ่านสูงสุด {config?.PWDLENGTH} ตัวอักษร
                </li>
                <li
                    style={{
                        color: passwordValidate['length']
                            ? 'green'
                            : 'white'
                    }}
                >
                    {' '}
                    รหัสผ่านขั้นต่ำ {config?.MINIMUMPWD} ตัวอักษร
                </li>
                {config?.RequireNumber?.toLowerCase() === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numNums']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        ตัวเลข
                    </li>
                )}
                {config?.RequireCharacterUpper?.toLowerCase() === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numUpper']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        ตัวอักษรพิมพ์ใหญ่
                    </li>
                )}
                {config?.RequireCharacterLower?.toLowerCase() === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numLower']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        ตัวอักษรพิมพ์เล็ก
                    </li>
                )}
                {config?.RequireSpecialCharacter?.toLowerCase() === 'true' && (
                    <li
                        style={{
                            color: passwordValidate['numSpecials']
                                ? 'green'
                                : 'white'
                        }}
                    >
                        ตัวอักษรพิเศษ
                    </li>
                )}
                <li
                    style={{
                        color: passwordValidate['username']
                            ? 'green'
                            : 'white'
                    }}
                >
                    {' '}
                    ไม่มีชื่อผู้ใช้ของคุณ
                </li>
            </ul>
        </ReactTooltip>
    )
}